import { calcTime } from '../lib/_tool.js';
import { setting } from './_setting.js';
let timeTarget = null;
const WAIT_TIME = 1500;
export let user = {
	miss: 0,
	name: "",
	currentSelect: [],
	got: [],
	isClear: false,
	result: {
		
	},
	checkCard: function( timer ){
		return new Promise((resolve, reject) => {
			let selects = user.currentSelect;
			let result = "";
			//console.log(selects);
			if( selects.length === 1 ){
				result = "next";
				resolve(result);
			}else if( selects.length === 2 ){
				if( selects[0] === selects[1] ){
					result = "success";
					user.got.push( selects[0] );
					user.currentSelect = [];
					user.addGotCard( selects[0] )
					resolve(result);
				}else{
					result = "fail";
					timer.addPenalty(5);
					user.miss++;
					document.querySelector(".c-miss dd span").innerHTML =  ( '00' + user.miss ).slice( -2 );
					user.addFailCard( user.currentSelect );
					setTimeout(function(){
						user.currentSelect.forEach( (id) => {
							let cards = document.querySelectorAll(`[data-id="${id}"]`);
							cards.forEach( (card) => {
								card.parentNode.classList.remove("select");
							});
						});
						user.currentSelect = [];
						resolve(result);
					}, WAIT_TIME);
				}
			}
		});
	},
	addGotCard: function( id ){
		let cards = document.querySelectorAll(`[data-id="${id}"]`);
		cards.forEach( (card) => {
			card.parentNode.classList.add("got");
		});
	},
	addFailCard: function( ids ){
		let lastCard;
		ids.forEach( ( id ) => {
			let cards = document.querySelectorAll(`[data-id="${id}"]`);
			
			cards.forEach( (card) => {
				if( card.parentNode.classList.contains("select") ){
					//console.log(card.parentNode);
					card.classList.add("fail");
					card.querySelector(".flip").addEventListener("transitionend", function(){
						card.classList.remove("fail");
					}, {
						"once": true
					});
				}
			});
		});
	}
}